/** @jsxImportSource @emotion/react */
import React from 'react';
import { jsx, css } from '@emotion/react';
import {useNotifications} from 'components/notification';
import Button from '@atlaskit/button';

type Props = {}

const PlaygroundPage: React.FC<Props> = (props) => {
  const {showSuccessNotification, showErrorNotification} = useNotifications();
  return (<div>
    <Button onClick={()=> {
      showSuccessNotification('Test notification','A very long and detailed description' );
      // showErrorNotification('Test error notification','A very long and detailed description' );
    }}>Add notification</Button>
    <Button onClick={()=> {
      showSuccessNotification('Test notification without description', );
    }}>Add short notification</Button>
    <Button onClick={()=> {
      showErrorNotification('Test error notification','A very long and detailed description' );
    }}>Add short notification</Button>
  </div>);
};

export default PlaygroundPage;
